<template>
    <div class="w-50 mt-4 mx-auto">
        <div class="mx-auto" ref="pixiContainer"></div>
    </div>
</template>

<script>
import { Application, Graphics, Container } from "pixi.js";
import Colours from "@/utils/Colours";

export default {
    async mounted() {
        this.app = new Application();

        await this.app.init({
            backgroundAlpha: 0,
            resizeTo: window,
        });

        this.$refs.pixiContainer.appendChild(this.app.canvas);

        // Green box
        const greenBox = new Graphics();
        greenBox.fill(Colours.SPORTLIGHT_TEAL);
        greenBox.rect(0, 0, 1000, 300);
        greenBox.fill();
        this.app.stage.addChild(greenBox);

        // Create container and add it to stage
        this.container = new Container();
        this.app.stage.addChild(this.container);

        // Red circle
        this.redCircle = new Graphics();
        this.redCircle.fill(Colours.PRIMARY_GREY);
        this.redCircle.circle(0, 0, 10);
        this.redCircle.fill();
        this.redCircle.x = 150;
        this.redCircle.y = 150;
        this.container.addChild(this.redCircle);

        // Velocity for random movement
        this.vx = 2 * (Math.random() * 2 - 1);
        this.vy = 2 * (Math.random() * 2 - 1);

        this.app.ticker.add(() => {
            this.redCircle.x += this.vx;
            this.redCircle.y += this.vy;

            const radius = 10;
            const boxWidth = 1000;
            const boxHeight = 300;

            if (this.redCircle.x > boxWidth - radius) {
                this.redCircle.x = boxWidth - radius;
                this.vx *= -1;
            } else if (this.redCircle.x < radius) {
                this.redCircle.x = radius;
                this.vx *= -1;
            }

            if (this.redCircle.y > boxHeight - radius) {
                this.redCircle.y = boxHeight - radius;
                this.vy *= -1;
            } else if (this.redCircle.y < radius) {
                this.redCircle.y = radius;
                this.vy *= -1;
            }

            this.vx += (Math.random() - 0.5) * 0.5;
            this.vy += (Math.random() - 0.5) * 0.5;
        });
    }
};
</script>
